/**
 * Normaliza texto para comparação: ignora espaços nas pontas, caixa e acento. Usado onde o
 * valor comparado vem do back (ex.: `descricaoStatus`) e a grafia pode variar.
 */
export function normalizarTexto(texto: string): string {
  return texto
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}
